module.exports = __webpack_public_path__ + "img/pay1.3d877dfa.png";